/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Banner_Tool_Access_Admins_TitleInputs */



/**
* | output |
* | --- |
* | "Tool access applies to administrators too" |
*
* @param {Rights_Banner_Tool_Access_Admins_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_banner_tool_access_admins_title = /** @type {((inputs?: Rights_Banner_Tool_Access_Admins_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Banner_Tool_Access_Admins_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Tool-Zugriff gilt auch für Administratoren")
	return /** @type {LocalizedString} */ ("Tool access applies to administrators too")
});